import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';

const StarRating = ({ rating = 0, max = 5, size = 'sm', interactive = false, onChange }) => {
  const sizes = { sm: 'text-sm', md: 'text-base', lg: 'text-xl' };

  const renderStar = (i) => {
    const full = rating >= i;
    const half = !full && rating >= i - 0.5;
    const Icon = full ? FaStar : half ? FaStarHalfAlt : FaRegStar;
    const color = full || half ? 'text-amber-400' : 'text-gray-300';

    if (interactive) {
      return (
        <button key={i} onClick={() => onChange && onChange(i)} className={`${color} ${sizes[size]} hover:text-amber-400 transition-colors`}>
          <FaStar />
        </button>
      );
    }

    return <Icon key={i} className={`${color} ${sizes[size]}`} />;
  };

  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: max }, (_, i) => renderStar(i + 1))}
    </div>
  );
};

export default StarRating;
